import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  AbsencesModule,
  GetAbsenceTimelineCardTitlePipe,
} from '@wilson/absences';
import { Absence } from '@wilson/interfaces';
import { DateTimeFormat } from '@wilson/utils';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { Store } from '@ngxs/store';
import { LocalizedDateTimeFormatPipe } from '@wilson/localization';

@Component({
  selector: 'wilson-timeline-absence-tooltip',
  templateUrl: './timeline-absence-tooltip.component.html',
  styleUrls: ['./timeline-absence-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AbsencesModule,
    TranslatePipe,
    NzTagModule,
    NzDividerModule,
    GetAbsenceTimelineCardTitlePipe,
    LocalizedDateTimeFormatPipe,
  ],
})
export class TimeLineAbsenceTooltipComponent {
  @Input() absence!: Absence;
  public DateTimeFormat = DateTimeFormat;
  public store = inject(Store);
}
